import { createClient } from "@supabase/supabase-js";

import { SUPABASE_PUBLISHABLE_KEY, SUPABASE_URL } from "./env";

/**
 * Supabase client configured from Vite environment variables.
 *
 * Expected vars (define in `.env` or Factory env settings):
 *  - VITE_SUPABASE_URL
 *  - VITE_SUPABASE_PUBLISHABLE_KEY
 *
 * ./env throws at import when either is missing (runtime guard; the build
 * guard is src/config/buildEnvGuard.ts).
 */

export const supabase = createClient(
  SUPABASE_URL,
  SUPABASE_PUBLISHABLE_KEY,
  {
    auth: {
      storage: localStorage,
      persistSession: true,
      autoRefreshToken: true,
      // PKCE for the OAuth (Google) authorization-code flow. Password sign-in
      // (signInWithPassword) ignores flowType, so this is behaviourally inert
      // for the existing email/password path. AuthFlowType = 'implicit' | 'pkce'.
      flowType: "pkce",
    },
  }
);
